import OverlayTips from "../OverlayTips";

function ArchivesPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

ArchivesPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".pagetitle span"), {
            messageKey: "tips.archives.title",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT
            }
        });

        this.add($(".listbuttonpane"), {
            messageKey: "tips.archives.buttons",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetY: -15
        });
    }
});

export default ArchivesPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/ArchivesPageOverlayTipsManager.js